import { useConfiguration } from "@/app/hooks/useConfiguration";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback, useState } from "react";
import toast from "react-hot-toast";
import AxiosCurlirize from "axios-curlirize";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useAPIUtils } from "@/app/hooks/useAPIUtils";
import { EMR_APIS } from "@/api_framework/api_config";

AxiosCurlirize(axios, () => {});

export interface IDiagnosis {
  id: string;
  title: string;
  aliases: string[];
}

interface IDiagnosisAPIResponse {
  status: boolean;
  message: string;
  data: IDiagnosis[];
}

export const useDiagnosisListAPI = () => {
  const { sendCurl } = useCurlLogger();
  const { captureError } = useAPIUtils();
  const configuration = useConfiguration();

  const [diagnosisList, setDiagnosisList] = useState<IDiagnosis[]>([]);
  const [loading, setLoading] = useState<boolean>(false);

  const execute = useCallback(async () => {
    try {
      setLoading(true);

      const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);

      await axios
        .get(
          `${EMR_APIS?.DIAGNOSIS_DATA?.baseURL}`,
          {
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          }
        )
        .then((res: AxiosResponse<IDiagnosisAPIResponse>) => {
          if (res.data?.status === true) {
            setDiagnosisList(res.data.data ?? []);
          } else {
            setDiagnosisList([]);
          }
        })
        .catch((e: AxiosError) => {
          sendCurl(e.config?.["curlCommand"]);
          captureError(e);
          setDiagnosisList([]);
        });
    } catch (e: any) {
      toast.error("Server Error: " + e.message);
      setDiagnosisList([]);
    } finally {
      setLoading(false);
    }
  }, [configuration.localStorage.ACCESS_TOKEN.key, sendCurl, captureError]);

  return {
    execute,
    diagnosisList,
    loading,
  };
};
